export const IFrameHelper = {
  sendMessage: (msg) => {
    window.parent.postMessage(`${JSON.stringify({ ...msg })}`, "*");
  },
};

export const setCookie = (key, value) => {
  try {
    if (typeof value === "object") value = JSON.stringify(value);
    localStorage.setItem(key, value);
  } catch {
    // Private / incognito mode may block storage in embedded iframes.
  }
};

export const getCookie = (key) => {
  try {
    let value = localStorage.getItem(key);
    if (value) value = JSON.parse(value);
    return value;
  } catch {
    return null;
  }
};
export const parseFirebaseDateTime = (timestamp, type = "datetime") => {
  if (!timestamp) timestamp = new Date();
  else timestamp = timestamp.toDate();

  const date = timestamp.toDateString();
  const time = `${
    (timestamp.getHours() < 10 ? "0" : "") + timestamp.getHours()
  }:${(timestamp.getMinutes() < 10 ? "0" : "") + timestamp.getMinutes()}`;

  if (type === "date") {
    return date;
  } else if (type === "time") {
    return time;
  } else {
    return `${date} ${time}`;
  }
};

export function sortByCreatedAt(data) {
  const sortedData = data?.sort((a, b) => {
    return b.created_at - a.created_at;
  });

  return sortedData;
}

export const getAgentInitials = (name, initial = false) => {
  if (initial) {
    return name
      .split(" ")
      .map((chunk) => chunk.charAt(0).toUpperCase())
      .join("");
  }
  return name;
};

export const checkTimeInBetween = (hoursRestriction, timezone) => {
  if (!hoursRestriction?.enabled) return true;
  // Specify the target timezone using the IANA timezone identifier
  const targetTimezone = timezone ? timezone : "Asia/Karachi";
  // Create a new Date object with the current time
  const currentDate = new Date();

  // Get the options for formatting the time
  const options = {
    timeZone: targetTimezone,
    hour12: false, // Set to true if you want 12-hour format
    hour: "numeric",
    minute: "numeric",
  };
  // Get the current time in the target timezone
  const currentTime = currentDate.toLocaleTimeString("en-US", options);
  const [startTime, endTime] = hoursRestriction?.values;

  // Case when the end time is earlier than the start time
  if (endTime < startTime) {
    const midnight = "23:59:59";
    const startTimeInverted = "00:00:00";
    const isBetween =
      (startTime <= currentTime && currentTime <= midnight) ||
      (startTimeInverted <= currentTime && currentTime <= endTime);

    return isBetween;
  }

  var isBetween = startTime <= currentTime && currentTime <= endTime;

  return isBetween;
};

/**
 * Cascade delivered/read ticks backward through visitor messages
 * (WhatsApp-style — same idea as old dashboard processMessages for agents).
 */
export function cascadeVisitorReceipts(messages) {
  if (!Array.isArray(messages) || messages.length === 0) return messages || [];

  let deliveredFound = false;
  let readFound = false;
  const next = messages.map((msg) => ({ ...msg }));

  for (let i = next.length - 1; i >= 0; i--) {
    const msg = next[i];
    if (!msg?.isVisitor) continue;

    if (msg.delivered) deliveredFound = true;
    if (deliveredFound && !msg.delivered) {
      msg.delivered = true;
    }

    if (msg.readStatus === 1) readFound = true;
    if (readFound && msg.readStatus !== 1) {
      msg.readStatus = 1;
      msg.delivered = true;
    }
  }

  return next;
}

/**
 * Pre-chat is required when the widget enables it and this session has not
 * completed the form yet (session.pre_chat === true after submit).
 */
export function sessionNeedsPreChat(widgetSettings, session) {
  if (!widgetSettings?.pre_chat_form) return false;
  return !session?.pre_chat;
}
